import React from 'react';
import { motion } from 'framer-motion';
import { Star, Brain, Zap, ShieldCheck } from 'lucide-react';
const items = [{
  icon: Star,
  label: 'Manifestación Real',
  sub: 'Resultados en 30 días'
}, {
  icon: Brain,
  label: 'Reprogramación Probada',
  sub: 'Neurociencia aplicada'
}, {
  icon: Zap,
  label: 'Acceso Inmediato',
  sub: 'Descarga al instante'
}, {
  icon: ShieldCheck,
  label: 'Garantía Total',
  sub: '7 días sin riesgo'
}];
export function TrustBar() {
  return <div className="bg-secondary border-y border-gold/15 py-6" data-id="element-264" data-mp="1uyzwfdyaag7z">
      <div className="max-w-[1100px] mx-auto px-5" data-id="element-265" data-mp="1uygh8500q5xn">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-266" data-mp="1gzqg8ea2vm40">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex flex-col items-center gap-2 p-3 md:p-4 text-center" data-id="element-267" data-mp="1lxij23c9gsmz" data-mpi={i}>
              <div className="w-11 h-11 bg-gold/10 border border-gold/25 rounded-full flex items-center justify-center text-gold" data-id="element-268" data-mp="1ajfcb2tj2fbe">
                <item.icon className="w-5 h-5" data-id="element-269" data-mp="16jog2jl8f6zh" />
              </div>
              <div data-id="element-270" data-mp="1kio3jnx0dfu2">
                <div className="text-[13px] font-semibold text-white" data-id="element-271" data-mp="1kf098mjqopea">{item.label}</div>
                <div className="text-[11px] text-gray-400" data-id="element-272" data-mp="1fgozscxcwgwl">{item.sub}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}